<template>
    <div aria-live="assertive">
        <div class="col-xs-12">
            <div class="d-flex-row flex-justify-between">
                <p id="title" role="heading" aria-level="1" tabindex="0">
                  <i class="fa fa-clock-o"></i>Agendar provas
                </p>
            </div>
        </div>
        <div v-if="!loading">
            <div class="col-xs-12 p-x-sm" v-if="result && result.length > 0">
                <div class="col-xs-12 col-md-6 col-lg-4 p-md" v-for="scheduling in getGroupedSchedulings()" :key="scheduling.id">
                    <div class="card p-20">
                        <div class="d-flex-row flex-justify-between m-b-md">
                            <div class="single-line">
                                <h4 class="level m-b-sm text-left" :key="academic"
                                    :title="academic.name"
                                    v-for="academic in scheduling.academics">{{ academic.name }}</h4>
                            </div>
                            <small class="info">
                                {{ scheduling.test_type.name }}
                            </small>
                        </div>
                        <div class="d-flex-column p-y-md text-left">
                            <b>Periodo de inscrições</b>
                            <span>{{ formatDbDatetime(scheduling.start_date) }}
                                a {{ formatDbDatetime(scheduling.end_date) }}</span>
                        </div>
                        <div v-if="scheduling.subscribed">
                            <div class="d-flex-column p-0 p-y-md text-left col-xs-8">
                                <b>Data/Hora da prova</b>
                                <span>{{ formatDbDatetime(scheduling.test_date.date) }}</span>
                            </div>
                            <div class="col-xs-4 p-y-md">
                                <button class="btn btn-default" @click="() => viewPlace = scheduling">Ver local</button>
                            </div>
                        </div>
                        <div class="d-flex-column p-y-md text-left" v-else>
                            &nbsp;<br/>&nbsp;
                        </div>
                        <div class="col-xs-12 m-t-lg">
                            <button class="col-xs-12 btn btn-primary" @click="() => openSubscriptionModal(scheduling)"
                                    v-if="!scheduling.subscribed">
                                Inscrever
                            </button>
                            <button class="col-xs-12 btn btn-danger" v-else-if="schedulingSubscribedFuture(scheduling)"
                                    @click="() => {cancellingSubscription = scheduling.subscribed}">
                                Cancelar inscrição
                            </button>
                        </div>
                    </div>
                </div>    
            </div>
            <div v-else>
                <span><b>Não há agendamentos disponíveis</b></span>
            </div>
        </div>
        <div role="presentation" v-else class="col-xs-12 d-flex-column align-center flex-justify-center text-center h-100vh overflow-hidden">
            <i class="fa fa-5x fa-circle-o-notch fa-spin"></i>
        </div>

        <modal-dialog v-show="viewPlace" @close="viewPlace = null;">
            <h3 class="text-left">Local de prova</h3>
            <template v-if="viewPlace">
                <div class="d-flex-column p-y-md text-left" v-for="placeData in getPlaceTree(viewPlace.test_date.place)" :key="placeData.name">
                    <b>{{ placeData.config }}</b>
                    <span>{{ placeData.name }}</span>
                </div>
            </template>
        </modal-dialog>

        <modal-dialog v-show="currentScheduling || modalData.loading" @close="currentScheduling = null; modalData.loading = false" mask-class="max-width">
            <div v-if="!currentScheduling || modalData.loading"
                 class="col-xs-12 d-flex-column align-center flex-justify-center text-center h-50vh overflow-hidden">
                <i class="fa fa-5x fa-circle-o-notch fa-spin"></i>
            </div>
            <div v-else-if="modalData.creating"
                class="col-xs-12 d-flex-column align-center flex-justify-center text-center overflow-hidden">
                <h3 class="text-left">Realizando inscrição...</h3>
                <p class="text-center">Sua inscrição está sendo realizada. Por favor, aguarde.</p>
                 <progress max="100" :value="progress" class="w-100 mt-3"></progress>
            </div>
            <div v-else class="col-xs-12 d-flex-column align-center flex-justify-center">
                <h3 class="text-left">Inscrever</h3>
                <div class="col-xs-12 p-0" v-if="currentScheduling.select_place">
                  <p class="text-left">Escolha o modo da sua pesquisa.</p>
                  <div class="m-b-md">
                      <label class="flex align-center">
                          <input type="radio" v-model="modalSelection.searchMode" value="date" @change="resetSelections" />
                          <span class="m-l-xs">Pesquisar por data</span>
                      </label>
                      <label class="flex align-center">
                          <input type="radio" v-model="modalSelection.searchMode" value="place" @change="resetSelections" />
                          <span class="m-l-xs">Pesquisar por local</span>
                      </label>
                  </div>
                </div>

              <!-- Se a pesquisa for por data -->
              <template v-if="currentScheduling.select_place ? modalSelection.searchMode === 'date' : true">
                <div class="col-xs-12 p-0 m-t-md input-select input">
                    <p class="text-left">Selecione a data da prova</p>
                    <label>Data</label>
                    <select v-model="modalSelection.date" class="w-100" @change="changeTestDate">
                        <option v-for="date in getTestDates()" :key="date" :value="date.value">
                            {{ date.label }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-12 p-0 m-t-md text-left" v-if="modalSelection.date">
                    <p>Selecione o horário da prova</p>
                    <div v-for="time in getTestTimes()"
                         :key="time" class="col-xs-6 p-0">
                        <input :value="time.value" type="radio" v-model="modalSelection.dateTime"
                               @change="modalSelection.places = []">
                        <span>{{ time.label }}</span>
                    </div>
                </div>
                <div class="col-xs-12 p-0 m-t-md text-left" v-if="modalSelection.dateTime && this.currentScheduling.select_place">
                    <p class="m-b-xs">Selecione o local da prova</p>
                    <div v-for="index in getPlaceOrders()"
                         :key="index" class="col-xs-6 p-0 input input-select m-t-md" :class="index % 2 === 0 ? 'p-r-md' : ''">
                        <label v-if="index === 0 || modalSelection.places[index-1]">
                            {{ getPlaceOptions(index)[0].config_name }}
                        </label>
                        <select class="w-100" v-if="index === 0 || modalSelection.places[index-1]"
                                v-model="modalSelection.places[index]" @change="changePlace(index)">
                            <option :value="undefined" class="d-none">Selecione</option>
                            <option v-for="option in getPlaceOptions(index)" :key="option" :value="option">
                                {{ formatPlaceOption(option) }}
                            </option>
                        </select>
                    </div>
                </div>
              </template>

              <!-- Se a pesquisa for por local -->
              <template v-else-if="currentScheduling.select_place && modalSelection.searchMode === 'place'">
                 <div class="col-xs-12 p-0 text-left">
                    <p class="m-b-xs">Selecione o local da prova</p>
                    <div v-for="index in getPlaceOrders()"
                         :key="index" class="col-xs-6 p-0 input input-select m-t-md" :class="index % 2 === 0 ? 'p-r-md' : ''">
                        <label v-if="index === 0 || modalSelection.places[index-1]">
                            {{ getPlaceOptions(index)[0].config_name }}
                        </label>
                        <select class="w-100" v-if="index === 0 || modalSelection.places[index-1]"
                                v-model="modalSelection.places[index]" @change="changePlace(index)">
                            <option :value="undefined" class="d-none">Selecione</option>
                            <option v-for="option in getPlaceOptions(index)" :key="option" :value="option">
                                {{ formatPlaceOption(option) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-xs-12 p-0 m-t-md input-select input" v-if="modalSelection.places && modalSelection.places.length === getPlaceOrders().length">
                    <p class="text-left">Selecione a data da prova</p>
                    <label>Data</label>
                    <select v-model="modalSelection.date" class="w-100" @change="changeTestDate">
                        <option v-for="date in getTestDates()" :key="date" :value="date.value">
                            {{ date.label }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-12 p-0 m-t-md text-left" v-if="modalSelection.date">
                    <p>Selecione o horário da prova</p>
                    <div v-for="time in getTestTimes()"
                         :key="time" class="col-xs-6 p-0">
                        <input :value="time.value" type="radio" v-model="modalSelection.dateTime"
                               @change="modalSelection.searchMode === 'date' ? modalSelection.places = [] : null">
                        <span>{{ time.label }}</span>
                    </div>
                </div>
              </template>

                <div class="col-xs-12 p-0 m-t-xl m-b-lg text-right">
                    <a class="btn btn-default m-r-md" @click="currentScheduling = null">Cancelar</a>
                    <button class="btn btn-primary" @click="saveSubscription"
                       v-bind="modalData.saving || !finishedForm() ? {disabled: 'disabled'} : {}">
                        <i class="fa fa-spin fa-circle-o-notch" v-if="modalData.saving"></i> Salvar</button>
                </div>
            </div>
        </modal-dialog>

        <modal-dialog v-show="successMsg" @close="successMsg = null">
            <div class="col-xs-12 d-flex-column align-center flex-justify-center">
                <h3 class="text-left">Inscrição finalizada</h3>
                <div class="col-xs-12 p-0 text-left m-t-xl" v-html="successMsg"></div>
                <div class="col-xs-12 p-0 text-right m-t-xl m-b-lg">
                    <a class="btn btn-primary" @click="successMsg = null">Entendi</a>
                </div>
            </div>
        </modal-dialog>

        <modal-dialog v-show="errorMsg" @close="errorMsg = null">
            <div class="col-xs-12 d-flex-column align-center flex-justify-center">
                <h3 class="text-left">Alerta</h3>
                <div class="col-xs-12 p-0 text-left m-t-xl">
                    {{ errorMsg }}
                </div>
                <div class="col-xs-12 p-0 text-right m-t-xl m-b-lg">
                    <a class="btn btn-primary" @click="errorMsg = null">Entendi</a>
                </div>
            </div>
        </modal-dialog>

        <modal-dialog v-show="cancellingSubscription" @close="cancellingSubscription = null">
            <div class="modal-contour vertical-center m-b-xl">
                <div class="p-0 form-group text-center">
                    <h4 class="text-bold m-0 color-danger">
                        Você tem certeza que quer cancelar a inscrição?
                    </h4>
                </div>
            </div>
            <div class="col-sm-12 p-0 buttons-container text-right">
                <span class="btn-container">
                    <button class="btn btn-default text-success m-r-lg"
                       @click="cancelSubscription()" v-bind="cancelling ? {disabled: true} : {}">
                        <i class="fa fa-circle-o-notch fa-spin" v-if="cancelling"></i> Sim</button>
                    <button class="btn btn-danger" @click="cancellingSubscription = null">Não</button>
                </span>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import {
    getSchedules,
    getSchedulingData, getSettings,
    getSubscription,
    postSchedulingSubscription,
    subscriptionCancel
} from "../../scripts/apiService/scheduling";
import { formatDbDate, formatDbDatetime } from "../../scripts/utils";
import ModalDialog from "../base/Modal";

    export default {
        name: 'SchedulingList',
        components: {ModalDialog},
        data: () => { return {
            result: null,
            currentScheduling: null,
            loading: false,
            modalData: {},
            modalSelection: {
              searchMode: 'date',
              date: null,
              dateTime: null,
              places: [],
            },
            successMsg: null,
            errorMsg: null,
            cancellingSubscription: null,
            cancelling: false,
            accessDate: new Date(),
            viewPlace: null,
            progress: 0,
        }},
        methods: {
            formatDbDate: formatDbDate,
            formatDbDatetime: formatDbDatetime,
            getPlaceTree(place) {
                let result = [{config: place.config_name, name: place.name}]
                let currParent = place;
                while (currParent.parent) {
                    currParent = currParent.parent;
                    result.unshift({config: currParent.config_name, name: currParent.name});
                }
                return result;
            },
            openSubscriptionModal(scheduling) {
                this.modalSelection = {
                    searchMode: scheduling.select_place ? 'date' : 'date',
                    places: [],
                    academics: Array.from(new Set(scheduling.academics.map(academic => academic.id)))
                };
                this.modalData.loading = true;
                this.modalData.candidateId = scheduling.candidate_id;
                this.modalData.academicNames = scheduling.academics.map(academic => academic.name);
                let academicId = scheduling.group_candidate_academics ? null : scheduling.academics[0].id
                getSchedulingData(this.$store.state.main.candidateInfo.client, scheduling.id, academicId).then((response) => {
                    this.currentScheduling = response.data;

                    let acadMap = response.data["academic_map"];
                    let placesMap = response.data["place_map"];
                    delete response.data["academic_map"];
                    delete response.data["place_map"];

                    this.currentScheduling.test_dates.forEach((testDate) => {
                        testDate.academics = testDate.academics.map((acadInfo) => {return {
                            "test_date_id": testDate.id,
                            "academic_id": acadInfo[1],
                            "id": acadInfo[0],
                            "academic": acadMap[acadInfo[1]]
                        }});
                        testDate.places = testDate.places.map((placeInfo) => placesMap[placeInfo[1]]);
                    });

                    this.modalData.loading = false;
                });
            },
            getTestDates() {
                let dates = [];
                let formattedDate;
                let testDates = this.currentScheduling.test_dates;

                if (this.modalSelection.searchMode === 'place' && this.modalSelection.places && this.modalSelection.places.length > 0) {
                    let selectedPlace = this.modalSelection.places[this.modalSelection.places.length - 1];
                    testDates = testDates.filter((testDate) => {
                        return testDate.places.some((place) => {
                          if (place.id === selectedPlace.id) {
                            return true;
                          }
                          let currentPlace = place;
                          while (currentPlace.parent) {
                            if (currentPlace.parent.id === selectedPlace.id) {
                              return true;
                            }
                            currentPlace = currentPlace.parent;
                          }
                          return false;
                        });
                    });
                }

                const futureTestDates = testDates.filter((testDate) => {
                    return new Date(testDate.date) >= new Date();
                });

                futureTestDates.sort((firstDate, secondDate) => new Date(firstDate.date) - new Date(secondDate.date))
                futureTestDates.forEach((testDate) => {
                    formattedDate = formatDbDatetime(testDate.date);
                    if (!dates.find((date) => formattedDate.split(" ")[0] === date.label)){
                        dates.push({
                            label: formattedDate.split(" ")[0],
                            value: formattedDate.split(" ")[0]
                        });
                    }
                });
                return dates;
            },
            changeTestDate() {
                this.modalSelection.dateTime = null;

                if (this.modalSelection.searchMode === 'date') {
                    this.modalSelection.places = [];
                }

            },
            getTestTimes() {
                let times = [];
                let formattedDate;
                let testTimes = this.currentScheduling.test_dates;

                if (!this.modalSelection.date){
                  return times;
                }

                if (this.modalSelection.searchMode === 'place' && this.modalSelection.places && this.modalSelection.places.length > 0) {
                    let selectedPlace = this.modalSelection.places[this.modalSelection.places.length - 1];
                    testTimes = testTimes.filter((testDate) => {
                      formattedDate = formatDbDatetime(testDate.date);
                      const dateMatches = formattedDate.split(" ")[0] === this.modalSelection.date;

                      if (!dateMatches) {
                        return false;
                      }

                      return testDate.places.some((place) => {
                        if (place.id === selectedPlace.id) {
                          return true;
                        }

                        let parent = place.parent;
                        while (parent) {
                          if (parent.id === selectedPlace.id) {
                            return true;
                          }
                          parent = parent.parent;
                        }
                        return false
                      })
                    })
                }

                testTimes.forEach((testDate) => {
                    formattedDate = formatDbDatetime(testDate.date);
                    if (formattedDate.split(" ")[0] === this.modalSelection.date) {
                        times.push({
                            label: formattedDate.split(" ")[1],
                            value: testDate
                        });
                    }
                });
                return times;
            },
            getPlaceOrders(){
                let testDate = this.currentScheduling.test_dates[0];
                let maxOrder = 1;
                let currentPlace = testDate.places[0];
                while (currentPlace.parent) {
                    maxOrder ++;
                    currentPlace = currentPlace.parent;
                }

                return Array.from({length: maxOrder}, (x, i) => i);
            },
            getPlaceOptions(index) {
                let parent = index > 0 ? this.modalSelection.places[index-1] : null;
                let testDates = this.currentScheduling.test_dates;

                if (this.modalSelection.searchMode === 'place') {
                  testDates = testDates.filter((testDate) => {
                    return new Date(testDate.date) >= new Date();
                  })
                }

                const testDate = testDates.length > 0 ? testDates[0] : this.currentScheduling.test_dates[0];

                if (!testDate || !testDate.places) return [];

                let testPlaceList = testDate.places.map((testDatePlace) =>
                    this.getParentFromOrder(testDatePlace, index + 1)
                );

                if (parent) {
                    testPlaceList = testPlaceList.filter((place) => place.parent.id === parent.id)
                }

                let uniquePlaces = [];
                testPlaceList.forEach((testPlace) => {
                    if (!uniquePlaces.find((place) => place.id === testPlace.id)){
                        uniquePlaces.push(testPlace);
                    }
                });

                return uniquePlaces.sort((firstPlace, secondPlace) => firstPlace.name.localeCompare(secondPlace.name))
            },
            getParentFromOrder(place, order){
                let currentPlace = place;
                while (currentPlace.config_order > order) {
                    currentPlace = currentPlace.parent;
                }
                return currentPlace;
            },
            formatPlaceOption(option) {
                if (!option.capacity) return option.name;
                const vacancy = option.capacity - option.subscriptions;
                const label = vacancy === 1 ? 'vaga disponível' : 'vagas disponíveis';
                return `${option.name} - ${vacancy} ${label}`;
            },
            changePlace(index) {
                this.modalSelection.places = this.modalSelection.places.slice(0, index + 1);

                 if (this.modalSelection.searchMode === 'place') {
                    this.modalSelection.date = null;
                    this.modalSelection.dateTime = null;
                }
            },
            saveSubscription() {
                let data = {
                    candidate_id: this.modalData.candidateId,
                    test_date_id: this.modalSelection.dateTime.id,
                    academics: this.modalSelection.academics,
                    access_date: this.accessDate,
                };

                if (this.currentScheduling.select_place) {
                    let place = this.modalSelection.places[this.modalSelection.places.length - 1];
                    data.place_id = place.id;
                }
                this.modalData.saving = true;
                postSchedulingSubscription(this.$store.state.main.candidateInfo.client, data)
                    .then(postResponse => {
                       
                        if (postResponse.data.status === 2) {
                            return this.onSubscriptionConfirmed(postResponse);
                        } else {
                            this.modalData.creating = true;
                            return this.pollSubscriptionStatus(postResponse.data);
                        }
                    })
                    .catch(error => {
                        this.errorMsg = error.response?.data?.message || error.message;
                        this.modalData.saving = false;
                    });
            },
            async pollSubscriptionStatus(data) {
                const maxDuration = 60000;
                const delay = 2000;
                let startTime = Date.now();
                this.progress = 0;
                if (this._progressInterval) clearInterval(this._progressInterval);
                this._progressInterval = setInterval(() => {
                    const elapsed = Date.now() - startTime;
                    this.progress = Math.min((elapsed / maxDuration) * 100, 89);
                    if (this.progress >= 89) {
                        clearInterval(this._progressInterval);
                    }
                }, 200);
                let running = true;
                while (running) {
                    const statusResponse = await getSubscription(
                        this.$store.state.main.candidateInfo.client,
                        data.id
                    );
                    if (statusResponse.data && statusResponse.data.status === 2) {
                        this.progress = 90;
                        clearInterval(this._progressInterval);
                        return this.onSubscriptionConfirmed(statusResponse);
                    }
                    if (statusResponse.data && statusResponse.data.status === 5) {
                        clearInterval(this._progressInterval);
                        this.modalData.saving = false;
                        this.modalData.creating = false;
                        this.errorMsg = "A inscrição falhou. Tente novamente.";
                        break;
                    }
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, delay));
                }
            },
            onSubscriptionConfirmed(response) {
                let msg = "Inscrição confirmada com sucesso!";
                this.progress = 100;
                getSettings(this.$store.state.main.candidateInfo.client, 1)
                    .then(settingsResponse => {
                        this.currentScheduling = null;
                        this.modalData.saving = false;
                        this.modalData.creating = false;
                        if (settingsResponse?.data?.value) {
                            msg = settingsResponse.data.value
                                .replace("{NOME}", this.$store.state.main.candidateInfo.firstName)
                                .replace("{DOCUMENTO}", this.$store.state.main.candidateInfo.documentId)
                                .replace("{ACADEMICO}", this.modalData.academicNames.join(", "))
                                .replace("{DATAHORAPROVA}", formatDbDatetime(this.modalSelection.dateTime.date))
                                .replace("{LOCALPROVA}", response?.data?.place?.name || "local não informado");
                            this.successMsg = msg;
                         } else {
                            this.successMsg = `Prezado(a) ${this.$store.state.main.candidateInfo.firstName}<br/><br/>Agradecemos o seu interesse e confirmamos que sua inscrição foi recebida com sucesso.<br/><br/>Em breve entraremos em contato com mais informações.`
                        }
                        this.loadInitial();
                    })
                   
            },
            getGroupedSchedulings() {
                let listing = [];
                let countedSchedules = {};
                this.result.forEach((scheduling) => {
                    let distinctKey = scheduling.id + '-' + (scheduling.group_candidate_academics ? '' : scheduling.academic.id);
                    let countedSchedule = countedSchedules[distinctKey];
                    if (countedSchedule) {
                        countedSchedule.subscribed = countedSchedule.subscribed || scheduling.subscribed;
                        countedSchedule.test_dates.push(scheduling.test_date);
                        if (!countedSchedule.academics.find(academic => academic.id === scheduling.academic.id))
                            countedSchedule.academics.push(scheduling.academic);
                        if (scheduling.subscribed)
                            countedSchedule.test_date = scheduling.test_date
                    } else {
                        let schedulingCopy = JSON.parse(JSON.stringify(scheduling));
                        delete schedulingCopy.academic;
                        if (!schedulingCopy.subscribed)
                            delete schedulingCopy.test_date;

                        countedSchedules[distinctKey] = schedulingCopy;
                        listing.push(schedulingCopy);

                        schedulingCopy.test_dates = [scheduling.test_date];
                        schedulingCopy.academics = [scheduling.academic];
                    }
                });
                return listing;
            },
            loadInitial() {
                this.loading = true;
                getSchedules().then((response) => {
                    this.result = response.data.schedule_periods;
                    this.loading = false;
                });
            },
            cancelSubscription() {
                this.cancelling = true;
               
                subscriptionCancel(
                    this.$store.state.main.candidateInfo.client,
                    this.cancellingSubscription
                )
                    .then(() => {
                        return this.pollCancelStatus(this.cancellingSubscription);
                    })
                    .catch(() => {
                        this.cancelling = false;
                        this.errorMsg ="Falha ao iniciar o cancelamento da inscrição.";
                    });
            },
            async pollCancelStatus(subscriptionId) {
                let delay = 2000;
                let running = true;
                while (running) {
                    const statusResponse = await getSubscription(
                        this.$store.state.main.candidateInfo.client,
                        subscriptionId
                    );
                    if (statusResponse.data && statusResponse.data.status === 4) {
                        this.result.forEach((scheduling) => {
                            if (scheduling.subscribed === subscriptionId) {
                                scheduling.subscribed = null;
                            }
                        });
                        this.cancelling = false;
                        this.cancellingSubscription = null;
                        this.successMsg = "Inscrição cancelada com sucesso!";
                        return true;
                    }
                    if (statusResponse.data && statusResponse.data.status === 5) {
                        this.cancelling = false;
                        this.cancellingSubscription = null;
                        this.errorMsg ="O cancelamento da inscrição falhou. Tente novamente.";
                        break;
                    }
                    await new Promise(resolve => setTimeout(resolve, delay));
                }
            },
            schedulingSubscribedFuture(obj) {
                const now = new Date();
                return new Date(obj.start_date) < now && now < new Date(obj.end_date);
            },
            finishedForm(){
              if (!this.modalSelection.searchMode) return false;

              if (!this.currentScheduling.select_place) {
                  return this.modalSelection.dateTime;
              }
              return this.modalSelection.places[this.getPlaceOrders().length - 1];
            },
            resetSelections() {
                this.modalSelection.date = null;
                this.modalSelection.dateTime = null;
                this.modalSelection.places = [];
            }
        },
        mounted() {
            this.loadInitial();
            this.modalData.creating = false;
            this.progress = 0;
            document.getElementById('title').focus();
        },
    }
</script>
